export { TableCell } from './tableCell.component';
